var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack184({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 4.5,
    width: 14,
    height: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.69,9.79V6.21H5.28v.42H3.16v1.1h2v.42h-2V9.37h2.2v.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.65,9.79,7,7.92,5.82,6.21h.56L7,7.13l.29.44a4.29,4.29,0,0,1,.28-.41l.72-1h.52L7.58,7.9,8.93,9.79H8.35l-.9-1.28a2.5,2.5,0,0,1-.16-.24l-.17.27-.9,1.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.43,9.79V6.21h.48V9.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.65,9.79V6.63H10.47V6.21h2.84v.42H12.12V9.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack184);
export default __webpack_public_path__ + "static/media/Symbolpack_1_84.091f8652f7cf533d4de3e2c2b40f9f39.svg";
export { ForwardRef as ReactComponent };